export enum EExportJobType {
  contacts = 'CONTACTS',
  orgMetrics = 'ORG_METRICS',
}

export enum EExportJobStatus {
  pending = 'PENDING',
  processing = 'PROCESSING',
  complete = 'COMPLETE',
  failed = 'FAILED',
}

export enum EExportDownloadError {
  notReady = 'EXPORT_NOT_READY',
  expired = 'EXPORT_EXPIRED',
}

export type TExportJobMeta = {
  rowCounts?: Record<string, number>
}

export type TExportJobPollResponse = {
  jobId: string
  status: EExportJobStatus
  error?: string
  url?: string
  downloadFilename?: string
  meta?: TExportJobMeta
}

export type TAsyncExportJob = {
  jobId: string
  type: EExportJobType
  label: string
  startedAt: number
  status: EExportJobStatus
  queryParams: Record<string, string>
  error?: string
  downloadFilename?: string
  readyModalDismissed?: boolean
  readyModalShown?: boolean
  meta?: TExportJobMeta
}

export type TStartExportJobResponse = {
  jobId: string
}
